module.exports = __webpack_public_path__ + "img/zhanwei.55faf3f1.png";